export default "__VITE_ASSET__ae144290__"